import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/shopInfo/page', data, {
    trim: true
  })
}

export function create (data) {
  return request.post('/business/shopInfo/create', data)
}

export function updateStatus (data) {
  return request.post('/business/shopInfo/updateStatus', data)
}

export function updateById (data) {
  return request.post('/business/shopInfo/updateShop', data)
}

export function deleteById (id) {
  return request.get(`/business/shopInfo/delete/${id}`)
}

export function deleteByIdInBatch (ids) {
  return request.get('/business/shopInfo/delete/batch', {
    params: {
      ids
    }
  })
}

// 修改门店状态
export function changeStatus (data) {
  return request.post('/business/shopInfo/changeStatus', data)
}

// 门店详情
export function detail (id) {
  return request.get(`/business/shopInfo/detail/${id}`)
}

// 重置密码
export function resetPassword (data) {
  return request.post('/business/shopInfo/resetPassword', data)
}

// 门店审批
export function audit (data) {
  return request.post('/business/shopInfo/audit', data)
}
